import { render, staticRenderFns } from "./CircleText.vue?vue&type=template&id=e3bee348&scoped=true&"
import script from "./CircleText.vue?vue&type=script&lang=js&"
export * from "./CircleText.vue?vue&type=script&lang=js&"
import style0 from "./CircleText.vue?vue&type=style&index=0&id=e3bee348&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3bee348",
  null
  
)

export default component.exports